<template>
  <b-container id="app" fluid>
    <router-view />
  </b-container>
</template>
<script>

import { FACEBOOK } from './config';

export default {

    methods: {
      setFacebookPixel(pixelId) {
        if (!pixelId) return;

        window.fbq = function() {
          if (fbq.callMethod) {
            fbq.callMethod.apply(fbq, arguments);
          } else {
            fbq.queue.push(arguments);
          }
        };
        window.fbq.push = window.fbq;
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
        window.fbq.queue = [];

        let script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);

        script.onload = () => {
          fbq('init', pixelId);
          fbq('track', 'PageView');
        };
      },
    },

    mounted() {
      this.setFacebookPixel(FACEBOOK.PIXEL_ID);
    },

  }
</script>
<style lang="scss">
/**
 * Firefox specific rule
 */
@-moz-document url-prefix() {
  body {
    font-weight: lighter !important;
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-smoothing: antialiased;
  font-weight: 400;
  min-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: auto;
  margin-right: auto;
}

@font-face {
  font-family: OpenSans;
  src: url(./assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(./assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(./assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

.support {
  color: #666666;
}

.alert-error {
  color: #ff0000;
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}

form {
  font-family: $font-family;
  font-size: $font-size-input;
  margin: auto;
  max-width: 415px;
  width: 100%;
  .input-group {
    margin: 0 0 8px 0;
    .formIcons {
      position: absolute;
      top: 1px;
      left: 1px;
      width: 57px;
      line-height: 53px;
      z-index: 100;
      svg {
        font-size: 16px;
        position: relative;
        z-index: 100;
        width: 57px;
        path {
          fill: $icon-color;
        }
      }
      &.email,
      &.password,
      &.coupon,
      &.creditcard {
        svg {
          font-size: 20px;
        }
      }
    }
    input {
      background: $bg-input;
      background-image: none !important;
      border: $border-input;
      border-radius: 6px !important;
      color: $color-input;
      font-size: $font-size-input;
      height: auto;
      line-height: $line-height-input;
      padding: $padding-input;
      &:focus {
        background-color: #ffffff;
        border: 1px solid #dcdcdc;
      }
    }
    .form-control {
      &:focus,
      .is-invalid,
      .is-valid {
        box-shadow: none;
      }
    }
    .invalid-feedback-custom {
      color: darkred;
    }
    .discount-apply {
      align-self: center;
      color: $color;
      cursor: pointer;
      font-size: 14px;
      font-weight: $font-bold;
      line-height: 36px;
      position: absolute;
      right: 35px;
      z-index: 99;
    }
    .discount-price {
      align-self: center;
      color: $color;
      font-weight: $font-bold;
      position: absolute;
      right: 0;
      .remove-coupon {
        cursor: pointer;
        display: inline-block;
        font-size: 24px;
        padding: 0px 11px;
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
      }
    }
  }
}

.form-title {
    color: #000000;
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 0;
    padding: 0px 0 40px;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
}

.green-button-white-text {
    background: #79b867;
    border: 1px solid #79b867;
    border-radius: 50px;
    color: #ffffff;
    font-size: 20px;
    font-weight: 700;
    line-height: 53px;
    margin-top: 8px;
    padding: 0 15px;
    text-transform: uppercase;
    width: 100%;
    .spinner-border {
      vertical-align: middle;
    }
    &:hover {
      background: #000000;
      border-color: #000000;
      color: #ffffff;
    }
    &:focus {
      outline: none;
    }
}

.page-container {
  padding: 0 !important;
}

@media screen and (max-width: 991px) {
  .checkout-content {
    .content {
      order: 2;
    }
    .checkout {
      order: 1;
    }
  }
}
</style>
